<template>
  <div class="container-fluid p-0">

    <div v-if="product.price == null && product.variation == 0">
      <div class="col-12 text-center">
        <m-a v-if="findAttributeOnSiteInfo('cell_phone')[0]  == undefined"
             :href="{ name: 'Product', params: { name: product.raw_link } }">
          <p class="text-center btn btn-primary mx-auto rounded-pill" v-t="'product.callText'"></p>
        </m-a>
        <a v-else :href="`tel:${findAttributeOnSiteInfo('cell_phone')[0]}`">
          <p class="text-center btn btn-primary mx-auto rounded-pill" v-t="'product.callText'"></p>
        </a>
      </div>
    </div>
    <div v-else>
      <div class="text-center" v-if="product.variation == 0">
        <div v-if="product.quantity > 0 || product.quantity == null " class="p-0 m-0 container-fluid">
          <div v-if="isProductActive(product)" class="p-0 m-0 justify-content-center text-center container-fluid">

            <div class="p-0 justify-content-center text-center">
              <a href="javascript:void(0)"
                 class="add-to-cart text-center py-1 px-4 text-dark text-center text-decoration-none"
                 @click="basketAddItem(product)" v-if="!checkOrder(product) && IsAuthenticated">
                {{ addToCartText }}
              </a>
              <a href="javascript:void(0)"
                 class="add-to-cart text-center py-1 px-4 text-dark text-center text-decoration-none"
                 @click="handleAddUnAuthItem(product)" v-if="!IsAuthenticated && !checkUnAuthBasket(product)">
                {{ addToCartText }}
              </a>
              <div class=""
                   v-if="!IsAuthenticated && checkUnAuthBasket(product)">
                <a href="javascript:void(0)" class="control-btn shadow"
                   @click="increaseUnAuthProductNumber(product,null)">
                  <m-icon icon="plus" class="shopping-cart-controller"/>
                </a>

                <span :id="findHashProductOnLocalStorage(product)+'-col'"
                      class="mx-3 product-quantity">{{
                    getUnAuthQuantityNumber(product)
                  }}</span>

                <a href="javascript:void(0)" class="control-btn ml-2 shadow"
                   @click="decreaseUnAuthProductNumber(product)"
                   v-if="getUnAuthQuantityNumber(product)>1">
                  <m-icon icon="dash" class="shopping-cart-controller"/>
                </a>

                <a href="javascript:void(0)" class="control-btn trash-controller"
                   @click="removeFromUnAuthOrder(product)">
                  <m-icon class="trash-controller text-danger" icon="trash"/>
                </a>

              </div>
            </div>

            <div class="justify-content-center p-0 w-100 text-center"
                 v-if="checkOrder(product) && IsAuthenticated">

              <a href="javascript:void(0)" class="control-btn shadow"
                 @click="changeItemQuantity(product, getQuantity(product.id), basket,'up')">
                <m-icon icon="plus" class="shopping-cart-controller"/>
              </a>

              <span class="mx-3 product-quantity">{{ getQuantity(product.id) }}</span>

              <a href="javascript:void(0)" class="control-btn ml-2 shadow"
                 @click="changeItemQuantity(product, getQuantity(product.id), basket,'down')"
                 v-if="getQuantity(product.id)>1">
                <m-icon icon="dash" class="shopping-cart-controller"/>
              </a>


              <a href="javascript:void(0)" class="control-btn trash-controller"
                 @click="removeFromOrder(product, basket)">
                <m-icon class="trash-controller text-danger" icon="trash"/>
              </a>

            </div>

          </div>

          <div v-else class="py-2 m-0 container">
            <div class="run-out-text">
              <div class="col">
                <span class="text-dark" v-t="'product.timing'"></span>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="container-fluid py-2 px-0 m-0">
          <div class="row text-center">
            <span class="text-muted font-weight-bold run-out-text" v-t="'product.out_of_quantity'"></span>
          </div>
        </div>
      </div>


      <div class="text-center" v-if="product.variation == 1">
        <div class="container-fluid justify-content-center p-0 m-0">
          <div class="p-0 m-0 container-fluid justify-content-center text-center">

            <div class="mt-2 row justify-content-center">

              <div class="" v-if="product.is_digital == 0">


                <a class="control-btn"
                   @click="increaseUnAuthProductNumber(product,product.sub_product_id)">
                  <m-icon icon="plus"/>
                </a>

                <span :id="product.id" class="mx-2">{{ getProductNumber(product) }}</span>


                <a class="control-btn" v-show="getProductNumber(product) > 1"
                   @click="decreaseUnAuthProductNumber(product)">
                  <m-icon icon="dash"/>
                </a>
              </div>

              <a class="mr-2" @click="removeProduct(product)">
                <m-icon class="text-danger" icon="trash"/>
              </a>

            </div>


          </div>

        </div>

      </div>
    </div>


  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {isProductActive} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Timing";
import {addUnAuthItem, basketAddItem} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";
import {findHashProductOnLocalStorage} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart';
import {subProducts} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import mA from '../Tags/A'
import mIcon from '../Icons/Icon'

export default {
  name: "ShoppingCartController1",
  components: {mA, mIcon},
  props: {
    product: {},
  },
  computed: {
    ...mapGetters({
      basket: "ShoppingCart/getSidebarBasketData",
      user_id: "User/getUserId"
    }),
    IsAuthenticated() {
      return this.$store.getters["User/isAuthenticated"];
    },
    addToCartText() {
      if (this.product.is_digital == 1) {
        return this.$t('product.add_to_cart_digital')
      }
      return this.$t('product.add_to_cart_physical')
    }
  },
  methods: {
    formatNumber,
    isProductActive,
    basketAddItem,
    addUnAuthItem,
    subProducts,
    findHashProductOnLocalStorage,
    checkOrder(product) {
      let result = false;
      if (this.basket.items !== undefined) {
        this.basket.items.forEach(item => {
          if (item.product.id === product.id) {
            result = true
          }
        })
      }
      return result
    },
    getQuantity(id) {
      let quantity = 0
      this.basket.items.forEach(item => {
        if (item.product.id === id) {
          quantity = item.quantity
        }
      })
      return quantity
    },
    getOrderItemId(product) {
      let itemId = 0
      this.basket.items.forEach(item => {
        if (item.product.id === product.id) {
          itemId = item.id
        }
      })
      return itemId
    },
    changeItemQuantity(product, quantity, basket, mode = 'up') {
      const form = {
        order_product_id: this.getOrderItemId(product),
        quantity: mode == 'up' ? quantity + 1 : quantity - 1,
        order_id: basket.id,
        user_id: this.user_id,
      };
      this.$store.dispatch("ShoppingCart/changeQuantityWithoutState", form)
          .then(res => {
            let response = res.data.data;
            this.$store.commit("ShoppingCart/setSidebarBasketData", response);
            this.$store.commit("ShoppingCart/setUserOrderUnpaidItems", response.items);
          })
          .catch(error => {

            this.$store.dispatch("ShoppingCart/userOrderUnpaid")


          })
    },
    removeFromOrder(product, basket) {
      this.$store.dispatch("ShoppingCart/removeItem", {
        order_product_id: this.getOrderItemId(product),
        order_id: basket.id
      })

    },
    checkUnAuthBasket(product) {
      if (localStorage.getItem('products') !== null) {
        return this.findHashProductOnLocalStorage(product) != undefined;
      } else {
        return false
      }
    },
    /* un-auth shopping cart management */
    getUnAuthQuantityNumber(product) {
      let products = JSON.parse(localStorage.getItem('products'));
      if (products == null) {
        return 0
      }
      return products[this.findHashProductOnLocalStorage(product)]['quantity']
    },
    async increaseUnAuthProductNumber(product, sub_product = null) {
      if (sub_product === null) {
        await this.addUnAuthItem(product, sub_product)
      } else {
        // todo find feature with selected

        let sub = '';
        this.subProducts(product).forEach(item => {
          if (item.sub_product_id == sub_product) {
            sub = item
            console.log(item)
          }
        })

        sub = {
          quantity: sub.sub_product_quantity,
          id: sub.sub_product_id,
        }
        console.log(sub)

        await this.addUnAuthItem(product, sub)
      }
      this.$emit('updateDelivery', true)
      this.$forceUpdate();
    },
    decreaseUnAuthProductNumber(product) {
      let products = JSON.parse(localStorage.getItem('products'));
      if (products[this.findHashProductOnLocalStorage(product)]['quantity'] > 1) {
        products[this.findHashProductOnLocalStorage(product)]['quantity']--;
      }
      localStorage.setItem('products', JSON.stringify(products));
      this.$emit('updateDelivery', true)
      this.$forceUpdate();
    },
    removeFromUnAuthOrder(product) {
      let products = JSON.parse(localStorage.getItem('products'));

      delete products[this.findHashProductOnLocalStorage(product)];
      let elementId = `un-auth-${this.findHashProductOnLocalStorage(product)}`

      try {
        document.getElementById(elementId).remove();
      } catch (e) {

      }

      localStorage.setItem('products', JSON.stringify(products));

      if (Object.keys(JSON.parse(localStorage.getItem('products'))).length == 0) {
        localStorage.removeItem('products')
      }
      this.$emit('updateDelivery', true)
      this.$forceUpdate();
    },
    async handleAddUnAuthItem(product) {
      await this.addUnAuthItem(product)
      this.$forceUpdate();
    },
    handleCardAfterChange() {
      this.$forceUpdate();
    },
    increaseProductNumber(product) {
      let products = JSON.parse(localStorage.getItem('products'));
      products[this.findHashProductOnLocalStorage(product)]['quantity']++;
      localStorage.setItem('products', JSON.stringify(products));
      let elementId = String(products[this.findHashProductOnLocalStorage(product)]['id'])
      document.getElementById(elementId).textContent = products[this.findHashProductOnLocalStorage(product)]['quantity'];
    },
    decreaseProductNumber(product) {
      let products = JSON.parse(localStorage.getItem('products'));
      if (products[this.findHashProductOnLocalStorage(product)]['quantity'] > 1) {
        products[this.findHashProductOnLocalStorage(product)]['quantity']--;
        let elementId = String(products[this.findHashProductOnLocalStorage(product)]['id'])
        document.getElementById(elementId).textContent = products[this.findHashProductOnLocalStorage(product)]['quantity'];
      }
      localStorage.setItem('products', JSON.stringify(products));
    },
    removeProduct(product) {
      let products = JSON.parse(localStorage.getItem('products'));

      delete products[this.findHashProductOnLocalStorage(product)];
      let elementId = `un-auth-${this.findHashProductOnLocalStorage(product)}`
      document.getElementById(elementId).remove();
      localStorage.setItem('products', JSON.stringify(products));
      this.$emit('updateDelivery', true)
    },
    getProductNumber(product) {
      let products = JSON.parse(localStorage.getItem('products'));
      if (products == null || Object.keys(products).length == 0 || products[this.findHashProductOnLocalStorage(product)] == null) {
        return 0
      }
      return products[this.findHashProductOnLocalStorage(product)]['quantity']
    },
  },
  mounted() {
    window.addEventListener('click', this.handleCardAfterChange);
    window.addEventListener('DOMContentLoaded', this.handleCardAfterChange);
  }
}
</script>

<style scoped>
.q-link {
  height: 25px;
  line-height: 10px;
  background-color: var(--secondary) !important;
  color: var(--light) !important;
}

.control-btn {
  width: 10px;
  height: 10px;
  text-decoration: none;
  padding: 3px 5px;
  margin: 0;
  color: white;
  font-weight: bold;
  border-radius: 100%;
  background-color: var(--primary) !important;
}

.add-to-cart {
  border-radius: 15px;
  background-color: var(--primary) !important;
  color: white !important;
}

.add-to-cart:hover {
  border-radius: 15px;
  background-color: var(--primary) !important;
  color: white !important;
}

.run-out-text {
  font-size: 13px;
}

.shopping-cart-controller {
  fill: white !important;
}

.trash-controller {
  background: transparent !important;
}

</style>